import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Cash Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const CashView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="cash"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default CashView;
